module.exports = __webpack_public_path__ + "img/user-fun.72e5b925.png";